<template>
  <b-card-body>
    <b-form-group label="Notitie">
      <b-textarea v-model="activiteit.omschrijving" />
    </b-form-group>
    
    <secure-bijlagen
      :bijlagen="activiteit.bijlagen"
    />

    <unit :unit="activiteit.unit" />

    <periode-hinder 
      :hinder="hinder" 
      @update-periode="onUpdatePeriode"
    />
    
    <hinder-details :hinder="hinder" />
  </b-card-body>
</template>

<script>
import SecureBijlagen from '../SecureBijlagen.vue';
import HinderDetails from './HinderDetails.vue';
import PeriodeHinder from './PeriodeHinder.vue';
import Unit from './Unit.vue';

export default {
  name: "UitvoeringStap",
  components: { PeriodeHinder, Unit, SecureBijlagen, HinderDetails },
  mixins: [],
  props: {
    authdocpath: {
      type: String,
      default: null,
    },
    activiteit: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      selectedUnit: null,
    };
  },
  computed: {
    days: function () {
      return Array.from({ length: this.hinder.periode }, (_, i) => i + 1).map((n) => {
          return {
            hinder: [],
            bevestigd: true,
            index: n - 1,
          };
        })
      },
    hinder: function () {
      return this.activiteit.hinder;
    },
  },
  watch: {},
  mounted() {},
  methods: {
    onUpdatePeriode(periode) {
      console.log("Periode aangepast ", periode);
      this.activiteit.datum = this.hinder.start
      this.hinder.periode = periode
      this.hinder.days = [...this.days]
    }
  },
};
</script>